import { makeAutoObservable } from "mobx"
import DraftShareAsset from "./DraftShareAsset"

export default class DraftShareVersion {

  constructor(version = {}) {
    this.id = version.id
    this.version_number = version.version_number
    this.caption = version.caption || ''
    this.notes = version.notes || ''
    this.co_author_response = version.co_author_response
    this.submitted_at = version.submitted_at
    this.draft_assets = version.draft_assets?.map(asset => new DraftShareAsset(asset)) || []
    this.checked_item_ids = (version.checklist_item_checks || []).filter(c => c.checked).map(c => c.checklist_item_id)
    this.feedback = version.feedback || []
    this.client_feedback_submitted = !!version.client_feedback_submitted
    // Only ever present when this version was loaded through the PM's own
    // authenticated blueprint chain (Campaigns::Drafts::DraftVersionBlueprint) -
    // the zero-auth influencer/client endpoints never send this key, so it
    // stays empty there. See that blueprint for why it can't live on the
    // shared one.
    this.client_feedback = version.client_feedback || []
    // Same PM-only story as client_feedback above - absent from the
    // zero-auth JSON, so this stays undefined there.
    this.submitted_via = version.submitted_via
    this.submitted_by = version.submitted_by
    this.client_recipient_emails = version.client_recipient_emails || []
    this.sent_to_client_at = version.sent_to_client_at

    makeAutoObservable(this)
  }

  get isSubmitted() {
    return !!this.submitted_at
  }

  isChecked(checklistItemId) {
    return this.checked_item_ids.includes(checklistItemId)
  }

  setChecked(checklistItemId, checked) {
    this.checked_item_ids = checked
      ? [...this.checked_item_ids, checklistItemId]
      : this.checked_item_ids.filter(id => id !== checklistItemId)
  }
}
